const constant = {
  BASE_URL: "https://hatchery.poultrac-tagashed.com:8888/",
};
module.exports = {
  ...constant,
};
